var items = {
  "block.minecraft.air": "udara",
  "block.minecraft.stone": "batu",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "granit digilap",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "diorit digilap",
  "block.minecraft.andesite": "andesit",
  "block.minecraft.polished_andesite": "andesit digilap",
  "block.minecraft.grass_block": "blok rumput",
  "block.minecraft.dirt": "tanah",
  "block.minecraft.coarse_dirt": "tanah kasar",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "nilium kirmizi",
  "block.minecraft.warped_nylium": "nilium gila",
  "block.minecraft.cobblestone": "batu buntar",
  "block.minecraft.oak_planks": "papan kayu oak",
  "block.minecraft.spruce_planks": "papan kayu cemara",
  "block.minecraft.birch_planks": "papan kayu birch",
  "block.minecraft.jungle_planks": "papan kayu rimba",
  "block.minecraft.acacia_planks": "papan kayu akasia",
  "block.minecraft.dark_oak_planks": "papan kayu oak gelap",
  "block.minecraft.crimson_planks": "papan kirmizi",
  "block.minecraft.warped_planks": "papan gila",
  "block.minecraft.oak_sapling": "anak pokok oak",
  "block.minecraft.spruce_sapling": "anak pokok cemara",
  "block.minecraft.birch_sapling": "anak pokok birch",
  "block.minecraft.jungle_sapling": "anak pokok rimba",
  "block.minecraft.acacia_sapling": "anak pokok akasia",
  "block.minecraft.dark_oak_sapling": "anak pokok oak gelap",
  "block.minecraft.bedrock": "batu dasar",
  "block.minecraft.sand": "pasir",
  "block.minecraft.red_sand": "pasir merah",
  "block.minecraft.gravel": "batu kelikir",
  "block.minecraft.gold_ore": "bijih emas",
  "block.minecraft.iron_ore": "bijih besi",
  "block.minecraft.coal_ore": "bijih arang batu",
  "block.minecraft.nether_gold_ore": "bijih emas nether",
  "block.minecraft.oak_log": "kayu balak oak",
  "block.minecraft.spruce_log": "kayu balak cemara",
  "block.minecraft.birch_log": "kayu balak birch",
  "block.minecraft.jungle_log": "kayu balak rimba",
  "block.minecraft.acacia_log": "kayu balak akasia",
  "block.minecraft.dark_oak_log": "kayu balak oak gelap",
  "block.minecraft.crimson_stem": "batang kirmizi",
  "block.minecraft.warped_stem": "batang gila",
  "block.minecraft.stripped_oak_log": "kayu balak oak terkupas kulit",
  "block.minecraft.stripped_spruce_log": "kayu balak cemara terkupas kulit",
  "block.minecraft.stripped_birch_log": "kayu balak birch terkupas kulit",
  "block.minecraft.stripped_jungle_log": "kayu balak rimba terkupas kulit",
  "block.minecraft.stripped_acacia_log": "kayu balak akasia terkupas kulit",
  "block.minecraft.stripped_dark_oak_log": "kayu balak oak gelap terkupas kulit",
  "block.minecraft.stripped_crimson_stem": "batang kirmizi terkupas kulit",
  "block.minecraft.stripped_warped_stem": "batang gila terkupas kulit",
  "block.minecraft.stripped_oak_wood": "kayu oak terkupas kulit",
  "block.minecraft.stripped_spruce_wood": "kayu cemara terkupas kulit",
  "block.minecraft.stripped_birch_wood": "kayu birch terkupas kulit",
  "block.minecraft.stripped_jungle_wood": "kayu rimba terkupas kulit",
  "block.minecraft.stripped_acacia_wood": "kayu akasia terkupas kulit",
  "block.minecraft.stripped_dark_oak_wood": "kayu oak gelap terkupas kulit",
  "block.minecraft.stripped_crimson_hyphae": "hifa kirmizi terkupas kulit",
  "block.minecraft.stripped_warped_hyphae": "hifa gila terkupas kulit",
  "block.minecraft.oak_wood": "kayu oak",
  "block.minecraft.spruce_wood": "kayu cemara",
  "block.minecraft.birch_wood": "kayu birch",
  "block.minecraft.jungle_wood": "kayu rimba",
  "block.minecraft.acacia_wood": "kayu akasia",
  "block.minecraft.dark_oak_wood": "kayu oak gelap",
  "block.minecraft.crimson_hyphae": "hifa kirmizi",
  "block.minecraft.warped_hyphae": "hifa gila",
  "block.minecraft.oak_leaves": "daun oak",
  "block.minecraft.spruce_leaves": "daun cemara",
  "block.minecraft.birch_leaves": "daun birch",
  "block.minecraft.jungle_leaves": "daun rimba",
  "block.minecraft.acacia_leaves": "daun akasia",
  "block.minecraft.dark_oak_leaves": "daun kayu oak gelap",
  "block.minecraft.sponge": "span",
  "block.minecraft.wet_sponge": "span basah",
  "block.minecraft.glass": "kaca",
  "block.minecraft.lapis_ore": "bijih lapis lazuli",
  "block.minecraft.lapis_block": "blok lapis lazuli",
  "block.minecraft.dispenser": "pengagih",
  "block.minecraft.sandstone": "batu pasir",
  "block.minecraft.chiseled_sandstone": "batu pasir terpahat",
  "block.minecraft.cut_sandstone": "batu pasir dipotong",
  "block.minecraft.note_block": "blok not",
  "block.minecraft.powered_rail": "landasan berkuasa",
  "block.minecraft.detector_rail": "landasan pengesan",
  "block.minecraft.sticky_piston": "omboh melekit",
  "block.minecraft.cobweb": "sarang labah-labah",
  "block.minecraft.grass": "rumput",
  "block.minecraft.fern": "paku pakis",
  "block.minecraft.dead_bush": "semak mati",
  "block.minecraft.seagrass": "rumput laut",
  "block.minecraft.sea_pickle": "jeruk laut",
  "block.minecraft.piston": "omboh",
  "block.minecraft.white_wool": "bulu putih",
  "block.minecraft.orange_wool": "bulu jingga",
  "block.minecraft.magenta_wool": "bulu magenta",
  "block.minecraft.light_blue_wool": "bulu biru muda",
  "block.minecraft.yellow_wool": "bulu kuning",
  "block.minecraft.lime_wool": "bulu hijau muda",
  "block.minecraft.pink_wool": "bulu merah jambu",
  "block.minecraft.gray_wool": "bulu kelabu",
  "block.minecraft.light_gray_wool": "bulu kelabu muda",
  "block.minecraft.cyan_wool": "bulu sian",
  "block.minecraft.purple_wool": "bulu ungu",
  "block.minecraft.blue_wool": "bulu biru",
  "block.minecraft.brown_wool": "bulu coklat",
  "block.minecraft.green_wool": "bulu hijau",
  "block.minecraft.red_wool": "bulu merah",
  "block.minecraft.black_wool": "bulu hitam",
  "block.minecraft.dandelion": "bunga kekwa",
  "block.minecraft.poppy": "popi",
  "block.minecraft.blue_orchid": "orkid biru",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "azure bluet",
  "block.minecraft.red_tulip": "tulip merah",
  "block.minecraft.orange_tulip": "tulip jingga",
  "block.minecraft.white_tulip": "tulip putih",
  "block.minecraft.pink_tulip": "tulip merah jambu",
  "block.minecraft.oxeye_daisy": "daisi oxeye",
  "block.minecraft.cornflower": "cornflower",
  "block.minecraft.lily_of_the_valley": "bakung lembah",
  "block.minecraft.wither_rose": "mawar wither",
  "block.minecraft.brown_mushroom": "cendawan perang",
  "block.minecraft.red_mushroom": "cendawan merah",
  "block.minecraft.crimson_fungus": "kulat kirmizi",
  "block.minecraft.warped_fungus": "kulat gila",
  "block.minecraft.crimson_roots": "akar kirmizi",
  "block.minecraft.warped_roots": "akar gila",
  "block.minecraft.nether_sprouts": "pucuk nether",
  "block.minecraft.weeping_vines": "penjalar menjulai",
  "block.minecraft.twisting_vines": "penjalar memulas",
  "block.minecraft.sugar_cane": "tebu",
  "block.minecraft.kelp": "kelp",
  "block.minecraft.bamboo": "buluh",
  "block.minecraft.gold_block": "blok emas",
  "block.minecraft.iron_block": "blok besi",
  "block.minecraft.oak_slab": "papak oak",
  "block.minecraft.spruce_slab": "papak cemara",
  "block.minecraft.birch_slab": "papak birch",
  "block.minecraft.jungle_slab": "papak rimba",
  "block.minecraft.acacia_slab": "papak akasia",
  "block.minecraft.dark_oak_slab": "papak oak gelap",
  "block.minecraft.crimson_slab": "papak kirmizi",
  "block.minecraft.warped_slab": "papak gila",
  "block.minecraft.stone_slab": "papak batu",
  "block.minecraft.smooth_stone_slab": "papak batu licin",
  "block.minecraft.sandstone_slab": "papak batu pasir",
  "block.minecraft.cut_sandstone_slab": "papak batu pasir dipotong",
  "block.minecraft.petrified_oak_slab": "papak oak membatu",
  "block.minecraft.cobblestone_slab": "papak batu buntar",
  "block.minecraft.brick_slab": "papak bata",
  "block.minecraft.stone_brick_slab": "papak batu bata",
  "block.minecraft.nether_brick_slab": "papak bata nether",
  "block.minecraft.quartz_slab": "papak kuarza",
  "block.minecraft.red_sandstone_slab": "papak batu pasir merah",
  "block.minecraft.cut_red_sandstone_slab": "papak batu pasir merah dipotong",
  "block.minecraft.purpur_slab": "papak purpur",
  "block.minecraft.prismarine_slab": "papak prismarin",
  "block.minecraft.prismarine_brick_slab": "papak bata prismarin",
  "block.minecraft.dark_prismarine_slab": "papak prismarin gelap",
  "block.minecraft.smooth_quartz": "blok kuarza licin",
  "block.minecraft.smooth_red_sandstone": "batu pasir merah licin",
  "block.minecraft.smooth_sandstone": "batu pasir licin",
  "block.minecraft.smooth_stone": "batu licin",
  "block.minecraft.bricks": "bata",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "rak buku",
  "block.minecraft.mossy_cobblestone": "batu buntar berlumut",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "obor",
  "block.minecraft.end_rod": "batang end",
  "block.minecraft.chorus_plant": "pokok korus",
  "block.minecraft.chorus_flower": "bunga korus",
  "block.minecraft.purpur_block": "blok purpur",
  "block.minecraft.purpur_pillar": "tonggak purpur",
  "block.minecraft.purpur_stairs": "tangga purpur",
  "block.minecraft.spawner": "penjelma",
  "block.minecraft.oak_stairs": "tangga oak",
  "block.minecraft.chest": "peti",
  "block.minecraft.diamond_ore": "bijih berlian",
  "block.minecraft.diamond_block": "blok berlian",
  "block.minecraft.crafting_table": "bangku kerja",
  "block.minecraft.farmland": "tanah ladang",
  "block.minecraft.furnace": "relau",
  "block.minecraft.ladder": "tangga",
  "block.minecraft.rail": "landasan",
  "block.minecraft.cobblestone_stairs": "tangga batu buntar",
  "block.minecraft.lever": "tuas",
  "block.minecraft.stone_pressure_plate": "plat tekanan batu",
  "block.minecraft.oak_pressure_plate": "plat tekanan oak",
  "block.minecraft.spruce_pressure_plate": "plat tekanan cemara",
  "block.minecraft.birch_pressure_plate": "plat tekanan birch",
  "block.minecraft.jungle_pressure_plate": "plat tekanan rimba",
  "block.minecraft.acacia_pressure_plate": "plat tekanan akasia",
  "block.minecraft.dark_oak_pressure_plate": "plat tekanan oak gelap",
  "block.minecraft.crimson_pressure_plate": "plat tekanan kirmizi",
  "block.minecraft.warped_pressure_plate": "plat tekanan gila",
  "block.minecraft.polished_blackstone_pressure_plate": "plat tekanan batu hitam digilap",
  "block.minecraft.redstone_ore": "bijih redstone",
  "block.minecraft.redstone_torch": "obor redstone",
  "block.minecraft.snow": "salji",
  "block.minecraft.ice": "ais",
  "block.minecraft.snow_block": "blok salji",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "tanah liat",
  "block.minecraft.jukebox": "peti lagu",
  "block.minecraft.oak_fence": "pagar kayu oak",
  "block.minecraft.spruce_fence": "pagar cemara",
  "block.minecraft.birch_fence": "pagar birch",
  "block.minecraft.jungle_fence": "pagar kayu rimba",
  "block.minecraft.acacia_fence": "pagar akasia",
  "block.minecraft.dark_oak_fence": "pagar kayu oak gelap",
  "block.minecraft.crimson_fence": "pagar kirmizi",
  "block.minecraft.warped_fence": "pagar gila",
  "block.minecraft.pumpkin": "labu",
  "block.minecraft.carved_pumpkin": "labu diukir",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "pasir roh",
  "block.minecraft.soul_soil": "tanah roh",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "basalt digilap",
  "block.minecraft.soul_torch": "obor roh",
  "block.minecraft.glowstone": "batu menyala",
  "block.minecraft.jack_o_lantern": "tanglung labu",
  "block.minecraft.oak_trapdoor": "pintu kolong oak",
  "block.minecraft.spruce_trapdoor": "pintu kolong cemara",
  "block.minecraft.birch_trapdoor": "pintu kolong birch",
  "block.minecraft.jungle_trapdoor": "pintu kolong rimba",
  "block.minecraft.acacia_trapdoor": "pintu kolong akasia",
  "block.minecraft.dark_oak_trapdoor": "pintu kolong oak gelap",
  "block.minecraft.crimson_trapdoor": "pintu kolong kirmizi",
  "block.minecraft.warped_trapdoor": "pintu kolong gila",
  "block.minecraft.infested_stone": "batu teremut",
  "block.minecraft.infested_cobblestone": "batu buntar teremut",
  "block.minecraft.infested_stone_bricks": "bata batu teremut",
  "block.minecraft.infested_mossy_stone_bricks": "bata batu berlumut teremut",
  "block.minecraft.infested_cracked_stone_bricks": "bata batu rekah teremut",
  "block.minecraft.infested_chiseled_stone_bricks": "bata batu terpahat teremut",
  "block.minecraft.stone_bricks": "bata batu",
  "block.minecraft.mossy_stone_bricks": "bata batu berlumut",
  "block.minecraft.cracked_stone_bricks": "bata batu rekah",
  "block.minecraft.chiseled_stone_bricks": "bata batu terpahat",
  "block.minecraft.brown_mushroom_block": "blok cendawan perang",
  "block.minecraft.red_mushroom_block": "blok cendawan merah",
  "block.minecraft.mushroom_stem": "batang cendawan",
  "block.minecraft.iron_bars": "palang besi",
  "block.minecraft.chain": "rantai",
  "block.minecraft.glass_pane": "anak kaca",
  "block.minecraft.melon": "tembikai",
  "block.minecraft.vine": "penjalar",
  "block.minecraft.oak_fence_gate": "pintu pagar kayu oak",
  "block.minecraft.spruce_fence_gate": "pintu pagar cemara",
  "block.minecraft.birch_fence_gate": "pintu pagar birch",
  "block.minecraft.jungle_fence_gate": "pintu pagar kayu rimba",
  "block.minecraft.acacia_fence_gate": "pintu pagar akasia",
  "block.minecraft.dark_oak_fence_gate": "pintu pagar oak gelap",
  "block.minecraft.crimson_fence_gate": "pintu pagar kirmizi",
  "block.minecraft.warped_fence_gate": "pintu pagar gila",
  "block.minecraft.brick_stairs": "tangga bata",
  "block.minecraft.stone_brick_stairs": "anak tangga batu bata",
  "block.minecraft.mycelium": "miselium",
  "block.minecraft.lily_pad": "tapak teratai",
  "block.minecraft.nether_bricks": "bata nether",
  "block.minecraft.cracked_nether_bricks": "bata nether rekah",
  "block.minecraft.chiseled_nether_bricks": "bata nether berukir",
  "block.minecraft.nether_brick_fence": "pagar bata nether",
  "block.minecraft.nether_brick_stairs": "tangga bata nether",
  "block.minecraft.enchanting_table": "meja penyihir",
  "block.minecraft.end_portal_frame": "bingkai gerbang end",
  "block.minecraft.end_stone": "batu end",
  "block.minecraft.end_stone_bricks": "bata batu end",
  "block.minecraft.dragon_egg": "telur naga",
  "block.minecraft.redstone_lamp": "lampu redstone",
  "block.minecraft.sandstone_stairs": "tangga batu pasir",
  "block.minecraft.emerald_ore": "bijih zamrud",
  "block.minecraft.ender_chest": "peti ender",
  "block.minecraft.tripwire_hook": "penyangkuk tali belantik",
  "block.minecraft.emerald_block": "blok zamrud",
  "block.minecraft.spruce_stairs": "tangga cemara",
  "block.minecraft.birch_stairs": "tangga birch",
  "block.minecraft.jungle_stairs": "tangga rimba",
  "block.minecraft.crimson_stairs": "tangga kirmizi",
  "block.minecraft.warped_stairs": "tangga gila",
  "block.minecraft.command_block": "blok perintah",
  "block.minecraft.beacon": "suar",
  "block.minecraft.cobblestone_wall": "tembok batu buntar",
  "block.minecraft.mossy_cobblestone_wall": "tembok batu buntar berlumut",
  "block.minecraft.brick_wall": "tembok bata",
  "block.minecraft.prismarine_wall": "tembok prismarin",
  "block.minecraft.red_sandstone_wall": "tembok batu pasir merah",
  "block.minecraft.mossy_stone_brick_wall": "tembok bata batu berlumut",
  "block.minecraft.granite_wall": "tembok granit",
  "block.minecraft.stone_brick_wall": "tembok bata batu",
  "block.minecraft.nether_brick_wall": "tembok bata nether",
  "block.minecraft.andesite_wall": "tembok andesit",
  "block.minecraft.red_nether_brick_wall": "tembok bata nether merah",
  "block.minecraft.sandstone_wall": "tembok batu pasir",
  "block.minecraft.end_stone_brick_wall": "tembok bata batu end",
  "block.minecraft.diorite_wall": "tembok diorit",
  "block.minecraft.blackstone_wall": "tembok batu hitam",
  "block.minecraft.polished_blackstone_wall": "tembok batu hitam digilap",
  "block.minecraft.polished_blackstone_brick_wall": "tembok bata batu hitam digilap",
  "block.minecraft.stone_button": "butang batu",
  "block.minecraft.oak_button": "butang oak",
  "block.minecraft.spruce_button": "butang cemara",
  "block.minecraft.birch_button": "butang birch",
  "block.minecraft.jungle_button": "butang rimba",
  "block.minecraft.acacia_button": "butang akasia",
  "block.minecraft.dark_oak_button": "butang oak gelap",
  "block.minecraft.crimson_button": "butang kirmizi",
  "block.minecraft.warped_button": "butang gila",
  "block.minecraft.polished_blackstone_button": "butang batu hitam digilap",
  "block.minecraft.anvil": "andas",
  "block.minecraft.chipped_anvil": "andas sumbing",
  "block.minecraft.damaged_anvil": "andas rosak",
  "block.minecraft.trapped_chest": "peti perangkap",
  "block.minecraft.light_weighted_pressure_plate": "plat tekanan ringan",
  "block.minecraft.heavy_weighted_pressure_plate": "plat tekanan berat",
  "block.minecraft.daylight_detector": "pengesan cahaya langit",
  "block.minecraft.redstone_block": "blok redstone",
  "block.minecraft.nether_quartz_ore": "bijih kuarza nether",
  "block.minecraft.hopper": "corong tuang",
  "block.minecraft.chiseled_quartz_block": "blok kuarza dipahat",
  "block.minecraft.quartz_block": "blok kuarza",
  "block.minecraft.quartz_bricks": "bata kuarza",
  "block.minecraft.quartz_pillar": "tonggak kuarza",
  "block.minecraft.quartz_stairs": "tangga kuarza",
  "block.minecraft.activator_rail": "landasan pengaktif",
  "block.minecraft.dropper": "penitis",
  "block.minecraft.white_terracotta": "terakota putih",
  "block.minecraft.orange_terracotta": "terakota jingga",
  "block.minecraft.magenta_terracotta": "terakota magenta",
  "block.minecraft.light_blue_terracotta": "terakota biru muda",
  "block.minecraft.yellow_terracotta": "terakota kuning",
  "block.minecraft.lime_terracotta": "terakota hijau muda",
  "block.minecraft.pink_terracotta": "terakota merah jambu",
  "block.minecraft.gray_terracotta": "terakota kelabu",
  "block.minecraft.light_gray_terracotta": "terakota kelabu muda",
  "block.minecraft.cyan_terracotta": "terakota sian",
  "block.minecraft.purple_terracotta": "terakota ungu",
  "block.minecraft.blue_terracotta": "terakota biru",
  "block.minecraft.brown_terracotta": "terakota coklat",
  "block.minecraft.green_terracotta": "terakota hijau",
  "block.minecraft.red_terracotta": "terakota merah",
  "block.minecraft.black_terracotta": "terakota hitam",
  "block.minecraft.barrier": "halangan",
  "block.minecraft.iron_trapdoor": "pintu kolong besi",
  "block.minecraft.hay_block": "bandela jerami",
  "block.minecraft.white_carpet": "permaidani putih",
  "block.minecraft.orange_carpet": "permaidani jingga",
  "block.minecraft.magenta_carpet": "permaidani magenta",
  "block.minecraft.light_blue_carpet": "permaidani biru muda",
  "block.minecraft.yellow_carpet": "permaidani kuning",
  "block.minecraft.lime_carpet": "permaidani hijau muda",
  "block.minecraft.pink_carpet": "permaidani merah jambu",
  "block.minecraft.gray_carpet": "permaidani kelabu",
  "block.minecraft.light_gray_carpet": "permaidani kelabu muda",
  "block.minecraft.cyan_carpet": "permaidani sian",
  "block.minecraft.purple_carpet": "permaidani ungu",
  "block.minecraft.blue_carpet": "permaidani biru",
  "block.minecraft.brown_carpet": "permaidani coklat",
  "block.minecraft.green_carpet": "permaidani hijau",
  "block.minecraft.red_carpet": "permaidani merah",
  "block.minecraft.black_carpet": "permaidani hitam",
  "block.minecraft.terracotta": "terakota",
  "block.minecraft.coal_block": "blok arang batu",
  "block.minecraft.packed_ice": "ais padat",
  "block.minecraft.acacia_stairs": "tangga akasia",
  "block.minecraft.dark_oak_stairs": "tangga oak gelap",
  "block.minecraft.slime_block": "blok lendir",
  "block.minecraft.grass_path": "laluan rumput",
  "block.minecraft.sunflower": "bunga matahari",
  "block.minecraft.lilac": "lilac",
  "block.minecraft.rose_bush": "semak ros",
  "block.minecraft.peony": "peony",
  "block.minecraft.tall_grass": "rumput panjang",
  "block.minecraft.large_fern": "paku pakis besar",
  "block.minecraft.white_stained_glass": "kaca berwarna putih",
  "block.minecraft.orange_stained_glass": "kaca berwarna jingga",
  "block.minecraft.magenta_stained_glass": "kaca berwarna magenta",
  "block.minecraft.light_blue_stained_glass": "kaca berwarna biru muda",
  "block.minecraft.yellow_stained_glass": "kaca berwarna kuning",
  "block.minecraft.lime_stained_glass": "kaca berwarna hijau muda",
  "block.minecraft.pink_stained_glass": "kaca berwarna merah jambu",
  "block.minecraft.gray_stained_glass": "kaca berwarna kelabu",
  "block.minecraft.light_gray_stained_glass": "kaca berwarna kelabu muda",
  "block.minecraft.cyan_stained_glass": "kaca berwarna sian",
  "block.minecraft.purple_stained_glass": "kaca berwarna ungu",
  "block.minecraft.blue_stained_glass": "kaca berwarna biru",
  "block.minecraft.brown_stained_glass": "kaca berwarna coklat",
  "block.minecraft.green_stained_glass": "kaca berwarna hijau",
  "block.minecraft.red_stained_glass": "kaca berwarna merah",
  "block.minecraft.black_stained_glass": "kaca berwarna hitam",
  "block.minecraft.white_stained_glass_pane": "anak kaca berwarna putih",
  "block.minecraft.orange_stained_glass_pane": "anak kaca berwarna jingga",
  "block.minecraft.magenta_stained_glass_pane": "anak kaca berwarna magenta",
  "block.minecraft.light_blue_stained_glass_pane": "anak kaca berwarna biru muda",
  "block.minecraft.yellow_stained_glass_pane": "anak kaca berwarna kuning",
  "block.minecraft.lime_stained_glass_pane": "anak kaca berwarna hijau muda",
  "block.minecraft.pink_stained_glass_pane": "anak kaca berwarna merah jambu",
  "block.minecraft.gray_stained_glass_pane": "anak kaca berwarna kelabu",
  "block.minecraft.light_gray_stained_glass_pane": "anak kaca berwarna kelabu muda",
  "block.minecraft.cyan_stained_glass_pane": "anak kaca berwarna sian",
  "block.minecraft.purple_stained_glass_pane": "anak kaca berwarna ungu",
  "block.minecraft.blue_stained_glass_pane": "anak kaca berwarna biru",
  "block.minecraft.brown_stained_glass_pane": "anak kaca berwarna coklat",
  "block.minecraft.green_stained_glass_pane": "anak kaca berwarna hijau",
  "block.minecraft.red_stained_glass_pane": "anak kaca berwarna merah",
  "block.minecraft.black_stained_glass_pane": "anak kaca berwarna hitam",
  "block.minecraft.prismarine": "prismarin",
  "block.minecraft.prismarine_bricks": "bata prismarin",
  "block.minecraft.dark_prismarine": "prismarin gelap",
  "block.minecraft.prismarine_stairs": "tangga prismarin",
  "block.minecraft.prismarine_brick_stairs": "tangga bata prismarin",
  "block.minecraft.dark_prismarine_stairs": "tangga prismarin gelap",
  "block.minecraft.sea_lantern": "tanglung laut",
  "block.minecraft.red_sandstone": "batu pasir merah",
  "block.minecraft.chiseled_red_sandstone": "batu pasir merah terpahat",
  "block.minecraft.cut_red_sandstone": "batu pasir merah dipotong",
  "block.minecraft.red_sandstone_stairs": "tangga batu pasir merah",
  "block.minecraft.repeating_command_block": "blok perintah berulang",
  "block.minecraft.chain_command_block": "blok perintah berantai",
  "block.minecraft.magma_block": "blok magma",
  "block.minecraft.nether_wart_block": "blok ketuat nether",
  "block.minecraft.warped_wart_block": "blok ketuat gila",
  "block.minecraft.red_nether_bricks": "bata merah nether",
  "block.minecraft.bone_block": "blok tulang",
  "block.minecraft.structure_void": "struktur kekosongan",
  "block.minecraft.observer": "pemerhati",
  "block.minecraft.shulker_box": "kotak shulker",
  "block.minecraft.white_shulker_box": "kotak shulker putih",
  "block.minecraft.orange_shulker_box": "kotak shulker jingga",
  "block.minecraft.magenta_shulker_box": "kotak shulker magenta",
  "block.minecraft.light_blue_shulker_box": "kotak shulker biru muda",
  "block.minecraft.yellow_shulker_box": "kotak shulker kuning",
  "block.minecraft.lime_shulker_box": "kotak shulker hijau muda",
  "block.minecraft.pink_shulker_box": "kotak shulker merah jambu",
  "block.minecraft.gray_shulker_box": "kotak shulker kelabu",
  "block.minecraft.light_gray_shulker_box": "kotak shulker kelabu muda",
  "block.minecraft.cyan_shulker_box": "kotak shulker sian",
  "block.minecraft.purple_shulker_box": "kotak shulker ungu",
  "block.minecraft.blue_shulker_box": "kotak shulker biru",
  "block.minecraft.brown_shulker_box": "kotak shulker coklat",
  "block.minecraft.green_shulker_box": "kotak shulker hijau",
  "block.minecraft.red_shulker_box": "kotak shulker merah",
  "block.minecraft.black_shulker_box": "kotak shulker hitam",
  "block.minecraft.white_glazed_terracotta": "terakota licau putih",
  "block.minecraft.orange_glazed_terracotta": "terakota licau jingga",
  "block.minecraft.magenta_glazed_terracotta": "terakota licau magenta",
  "block.minecraft.light_blue_glazed_terracotta": "terakota licau biru muda",
  "block.minecraft.yellow_glazed_terracotta": "terakota licau kuning",
  "block.minecraft.lime_glazed_terracotta": "terakota licau hijau muda",
  "block.minecraft.pink_glazed_terracotta": "terakota licau merah jambu",
  "block.minecraft.gray_glazed_terracotta": "terakota licau kelabu",
  "block.minecraft.light_gray_glazed_terracotta": "terakota licau kelabu muda",
  "block.minecraft.cyan_glazed_terracotta": "terakota licau sian",
  "block.minecraft.purple_glazed_terracotta": "terakota licau ungu",
  "block.minecraft.blue_glazed_terracotta": "terakota licau biru",
  "block.minecraft.brown_glazed_terracotta": "terakota licau coklat",
  "block.minecraft.green_glazed_terracotta": "terakota licau hijau",
  "block.minecraft.red_glazed_terracotta": "terakota licau merah",
  "block.minecraft.black_glazed_terracotta": "terakota licau hitam",
  "block.minecraft.white_concrete": "konkrit putih",
  "block.minecraft.orange_concrete": "konkrit jingga",
  "block.minecraft.magenta_concrete": "konkrit magenta",
  "block.minecraft.light_blue_concrete": "konkrit biru muda",
  "block.minecraft.yellow_concrete": "konkrit kuning",
  "block.minecraft.lime_concrete": "konkrit hijau muda",
  "block.minecraft.pink_concrete": "konkrit merah jambu",
  "block.minecraft.gray_concrete": "konkrit kelabu",
  "block.minecraft.light_gray_concrete": "konkrit kelabu muda",
  "block.minecraft.cyan_concrete": "konkrit sian",
  "block.minecraft.purple_concrete": "konkrit ungu",
  "block.minecraft.blue_concrete": "konkrit biru",
  "block.minecraft.brown_concrete": "konkrit coklat",
  "block.minecraft.green_concrete": "konkrit hijau",
  "block.minecraft.red_concrete": "konkrit merah",
  "block.minecraft.black_concrete": "konkrit hitam",
  "block.minecraft.white_concrete_powder": "serbuk konkrit putih",
  "block.minecraft.orange_concrete_powder": "serbuk konkrit jingga",
  "block.minecraft.magenta_concrete_powder": "serbuk konkrit magenta",
  "block.minecraft.light_blue_concrete_powder": "serbuk konkrit biru muda",
  "block.minecraft.yellow_concrete_powder": "serbuk konkrit kuning",
  "block.minecraft.lime_concrete_powder": "serbuk konkrit hijau muda",
  "block.minecraft.pink_concrete_powder": "serbuk konkrit merah jambu",
  "block.minecraft.gray_concrete_powder": "serbuk konkrit kelabu",
  "block.minecraft.light_gray_concrete_powder": "serbuk konkrit kelabu muda",
  "block.minecraft.cyan_concrete_powder": "serbuk konkrit sian",
  "block.minecraft.purple_concrete_powder": "serbuk konkrit ungu",
  "block.minecraft.blue_concrete_powder": "serbuk konkrit biru",
  "block.minecraft.brown_concrete_powder": "serbuk konkrit coklat",
  "block.minecraft.green_concrete_powder": "serbuk konkrit hijau",
  "block.minecraft.red_concrete_powder": "serbuk konkrit merah",
  "block.minecraft.black_concrete_powder": "serbuk konkrit hitam",
  "block.minecraft.turtle_egg": "telur penyu",
  "block.minecraft.dead_tube_coral_block": "blok karang tiub mati",
  "block.minecraft.dead_brain_coral_block": "blok karang otak mati",
  "block.minecraft.dead_bubble_coral_block": "blok karang buih mati",
  "block.minecraft.dead_fire_coral_block": "blok karang api mati",
  "block.minecraft.dead_horn_coral_block": "blok karang tanduk mati",
  "block.minecraft.tube_coral_block": "blok karang tiub",
  "block.minecraft.brain_coral_block": "blok karang otak",
  "block.minecraft.bubble_coral_block": "blok karang buih",
  "block.minecraft.fire_coral_block": "blok karang api",
  "block.minecraft.horn_coral_block": "blok karang tanduk",
  "block.minecraft.tube_coral": "karang tiub",
  "block.minecraft.brain_coral": "karang otak",
  "block.minecraft.bubble_coral": "karang buih",
  "block.minecraft.fire_coral": "karang api",
  "block.minecraft.horn_coral": "karang tanduk",
  "block.minecraft.dead_brain_coral": "karang otak mati",
  "block.minecraft.dead_bubble_coral": "karang buih mati",
  "block.minecraft.dead_fire_coral": "karang api mati",
  "block.minecraft.dead_horn_coral": "akar tanduk mati",
  "block.minecraft.dead_tube_coral": "karang tiub mati",
  "block.minecraft.tube_coral_fan": "akar bahar tiub",
  "block.minecraft.brain_coral_fan": "akar bahar otak",
  "block.minecraft.bubble_coral_fan": "akar bahar buih",
  "block.minecraft.fire_coral_fan": "akar bahar api",
  "block.minecraft.horn_coral_fan": "akar bahar tanduk",
  "block.minecraft.dead_tube_coral_fan": "akar bahar tiub mati",
  "block.minecraft.dead_brain_coral_fan": "akar bahar otak mati",
  "block.minecraft.dead_bubble_coral_fan": "akar bahar buih mati",
  "block.minecraft.dead_fire_coral_fan": "akar bahar api mati",
  "block.minecraft.dead_horn_coral_fan": "akar bahar tanduk mati",
  "block.minecraft.blue_ice": "ais biru",
  "block.minecraft.conduit": "pembuluh",
  "block.minecraft.polished_granite_stairs": "tangga granit digilap",
  "block.minecraft.smooth_red_sandstone_stairs": "tangga batu pasir merah licin",
  "block.minecraft.mossy_stone_brick_stairs": "tangga batu bata berlumut",
  "block.minecraft.polished_diorite_stairs": "tangga diorit digilap",
  "block.minecraft.mossy_cobblestone_stairs": "tangga batu buntar berlumut",
  "block.minecraft.end_stone_brick_stairs": "tangga bata batu end",
  "block.minecraft.stone_stairs": "tangga batu",
  "block.minecraft.smooth_sandstone_stairs": "tangga batu pasir licin",
  "block.minecraft.smooth_quartz_stairs": "tangga kuarza licin",
  "block.minecraft.granite_stairs": "tangga granit",
  "block.minecraft.andesite_stairs": "tangga andesit",
  "block.minecraft.red_nether_brick_stairs": "tangga bata nether merah",
  "block.minecraft.polished_andesite_stairs": "tangga andesit digilap",
  "block.minecraft.diorite_stairs": "tangga diorit",
  "block.minecraft.polished_granite_slab": "papak granit digilap",
  "block.minecraft.smooth_red_sandstone_slab": "papak batu pasir merah licin",
  "block.minecraft.mossy_stone_brick_slab": "papak bata batu berlumut",
  "block.minecraft.polished_diorite_slab": "papak diorit digilap",
  "block.minecraft.mossy_cobblestone_slab": "papak batu buntar berlumut",
  "block.minecraft.end_stone_brick_slab": "papak batu bata end",
  "block.minecraft.smooth_sandstone_slab": "papak batu pasir licin",
  "block.minecraft.smooth_quartz_slab": "papak kuarza licin",
  "block.minecraft.granite_slab": "papak granit",
  "block.minecraft.andesite_slab": "papak andesit",
  "block.minecraft.red_nether_brick_slab": "papak bata nether merah",
  "block.minecraft.polished_andesite_slab": "papak andesit digilap",
  "block.minecraft.diorite_slab": "papak diorit",
  "block.minecraft.scaffolding": "perancah",
  "block.minecraft.iron_door": "pintu besi",
  "block.minecraft.oak_door": "pintu kayu oak",
  "block.minecraft.spruce_door": "pintu kayu cemara",
  "block.minecraft.birch_door": "pintu kayu birch",
  "block.minecraft.jungle_door": "pintu kayu rimba",
  "block.minecraft.acacia_door": "pintu kayu akasia",
  "block.minecraft.dark_oak_door": "pintu kayu oak gelap",
  "block.minecraft.crimson_door": "pintu kirmizi",
  "block.minecraft.warped_door": "pintu gila",
  "block.minecraft.repeater": "pengulang redstone",
  "block.minecraft.comparator": "pembanding redstone",
  "block.minecraft.structure_block": "blok struktur",
  "block.minecraft.jigsaw": "blok suai-jodoh",
  "item.minecraft.turtle_helmet": "karapas penyu□□apabila di kepala:□+2 zirah",
  "item.minecraft.scute": "skut",
  "item.minecraft.iron_shovel": "penyodok besi□□apabila dalam tangan utama:□+3.5 kecederaan serangan□-3 kelajuan serangan",
  "item.minecraft.iron_pickaxe": "beliung besi□□apabila dalam tangan utama:□+3 kecederaan serangan□-2.8 kelajuan serangan",
  "item.minecraft.iron_axe": "kapak besi□□apabila dalam tangan utama:□+8 kecederaan serangan□-3.1 kelajuan serangan",
  "item.minecraft.flint_and_steel": "pemetik api",
  "item.minecraft.apple": "epal",
  "item.minecraft.bow": "busur",
  "item.minecraft.arrow": "anak panah",
  "item.minecraft.coal": "arang batu",
  "item.minecraft.charcoal": "arang",
  "item.minecraft.diamond": "berlian",
  "item.minecraft.iron_ingot": "jongkong besi",
  "item.minecraft.gold_ingot": "jongkong emas",
  "item.minecraft.netherite_ingot": "jongkong netherit",
  "item.minecraft.netherite_scrap": "netherit sekerap",
  "item.minecraft.iron_sword": "pedang besi□□apabila dalam tangan utama:□+5 kecederaan serangan□-2.4 kelajuan serangan",
  "item.minecraft.wooden_sword": "pedang kayu□□apabila dalam tangan utama:□+3 kecederaan serangan□-2.4 kelajuan serangan",
  "item.minecraft.wooden_shovel": "penyodok kayu□□apabila dalam tangan utama:□+1.5 kecederaan serangan□-3 kelajuan serangan",
  "item.minecraft.wooden_pickaxe": "beliung kayu□□apabila dalam tangan utama:□+1 kecederaan serangan□-2.8 kelajuan serangan",
  "item.minecraft.wooden_axe": "kapak kayu□□apabila dalam tangan utama:□+6 kecederaan serangan□-3.2 kelajuan serangan",
  "item.minecraft.stone_sword": "pedang batu□□apabila dalam tangan utama:□+4 kecederaan serangan□-2.4 kelajuan serangan",
  "item.minecraft.stone_shovel": "penyodok batu□□apabila dalam tangan utama:□+2.5 kecederaan serangan□-3 kelajuan serangan",
  "item.minecraft.stone_pickaxe": "beliung batu□□apabila dalam tangan utama:□+2 kecederaan serangan□-2.8 kelajuan serangan",
  "item.minecraft.stone_axe": "kapak batu□□apabila dalam tangan utama:□+8 kecederaan serangan□-3.2 kelajuan serangan",
  "item.minecraft.diamond_sword": "pedang berlian□□apabila dalam tangan utama:□+6 kecederaan serangan□-2.4 kelajuan serangan",
  "item.minecraft.diamond_shovel": "penyodok berlian□□apabila dalam tangan utama:□+4.5 kecederaan serangan□-3 kelajuan serangan",
  "item.minecraft.diamond_pickaxe": "beliung berlian□□apabila dalam tangan utama:□+4 kecederaan serangan□-2.8 kelajuan serangan",
  "item.minecraft.diamond_axe": "kapak berlian□□apabila dalam tangan utama:□+8 kecederaan serangan□-3 kelajuan serangan",
  "item.minecraft.stick": "batang kayu",
  "item.minecraft.bowl": "mangkuk",
  "item.minecraft.mushroom_stew": "stu cendawan",
  "item.minecraft.golden_sword": "pedang emas□□apabila dalam tangan utama:□+3 kecederaan serangan□-2.4 kelajuan serangan",
  "item.minecraft.golden_shovel": "penyodok emas□□apabila dalam tangan utama:□+1.5 kecederaan serangan□-3 kelajuan serangan",
  "item.minecraft.golden_pickaxe": "beliung emas□□apabila dalam tangan utama:□+1 kecederaan serangan□-2.8 kelajuan serangan",
  "item.minecraft.golden_axe": "kapak emas□□apabila dalam tangan utama:□+6 kecederaan serangan□-3 kelajuan serangan",
  "item.minecraft.netherite_sword": "pedang netherit□□apabila dalam tangan utama:□+7 kecederaan serangan□-2.4 kelajuan serangan",
  "item.minecraft.netherite_shovel": "penyodok netherit□□apabila dalam tangan utama:□+5.5 kecederaan serangan□-3 kelajuan serangan",
  "item.minecraft.netherite_pickaxe": "beliung netherit□□apabila dalam tangan utama:□+5 kecederaan serangan□-2.8 kelajuan serangan",
  "item.minecraft.netherite_axe": "kapak netherit□□apabila dalam tangan utama:□+9 kecederaan serangan□-3 kelajuan serangan",
  "item.minecraft.string": "tali",
  "item.minecraft.feather": "bulu pelepah",
  "item.minecraft.gunpowder": "serbuk letupan",
  "item.minecraft.wooden_hoe": "cangkul kayu□□apabila dalam tangan utama:□-3 kelajuan serangan",
  "item.minecraft.stone_hoe": "cangkul batu□□apabila dalam tangan utama:□-2 kelajuan serangan",
  "item.minecraft.iron_hoe": "cangkul besi□□apabila dalam tangan utama:□-1 kelajuan serangan",
  "item.minecraft.diamond_hoe": "cangkul berlian□□apabila dalam tangan utama:",
  "item.minecraft.golden_hoe": "cangkul emas□□apabila dalam tangan utama:□-3 kelajuan serangan",
  "item.minecraft.netherite_hoe": "cangkul netherit□□apabila dalam tangan utama:",
  "item.minecraft.wheat_seeds": "benih gandum",
  "item.minecraft.wheat": "gandum",
  "item.minecraft.bread": "roti",
  "item.minecraft.leather_helmet": "topi kulit□□apabila di kepala:□+1 zirah",
  "item.minecraft.leather_chestplate": "jubah kulit□□apabila di badan:□+3 zirah",
  "item.minecraft.leather_leggings": "seluar kulit□□apabila di kaki:□+2 zirah",
  "item.minecraft.leather_boots": "but kulit□□apabila di tapak kaki:□+1 zirah",
  "item.minecraft.chainmail_helmet": "ketopong rantai□□apabila di kepala:□+2 zirah",
  "item.minecraft.chainmail_chestplate": "zirah dada rantai□□apabila di badan:□+5 zirah",
  "item.minecraft.chainmail_leggings": "zirah kaki rantai□□apabila di kaki:□+4 zirah",
  "item.minecraft.chainmail_boots": "but rantai□□apabila di tapak kaki:□+1 zirah",
  "item.minecraft.iron_helmet": "ketopong besi□□apabila di kepala:□+2 zirah",
  "item.minecraft.iron_chestplate": "zirah dada besi□□apabila di badan:□+6 zirah",
  "item.minecraft.iron_leggings": "zirah kaki besi□□apabila di kaki:□+5 zirah",
  "item.minecraft.iron_boots": "but besi□□apabila di tapak kaki:□+2 zirah",
  "item.minecraft.diamond_helmet": "ketopong berlian□□apabila di kepala:□+3 zirah□+2 ketahanan zirah",
  "item.minecraft.diamond_chestplate": "zirah dada berlian□□apabila di badan:□+8 zirah□+2 ketahanan zirah",
  "item.minecraft.diamond_leggings": "zirah kaki berlian□□apabila di kaki:□+6 zirah□+2 ketahanan zirah",
  "item.minecraft.diamond_boots": "but berlian□□apabila di tapak kaki:□+3 zirah□+2 ketahanan zirah",
  "item.minecraft.golden_helmet": "ketopong emas□□apabila di kepala:□+2 zirah",
  "item.minecraft.golden_chestplate": "zirah dada emas□□apabila di badan:□+5 zirah",
  "item.minecraft.golden_leggings": "zirah kaki emas□□apabila di kaki:□+3 zirah",
  "item.minecraft.golden_boots": "but emas□□apabila di tapak kaki:□+1 zirah",
  "item.minecraft.netherite_helmet": "ketopong netherit□□apabila di kepala:□+3 zirah□+3 ketahanan zirah□+1 ketahanan balas",
  "item.minecraft.netherite_chestplate": "zirah dada netherit□□apabila di badan:□+8 zirah□+3 ketahanan zirah□+1 ketahanan balas",
  "item.minecraft.netherite_leggings": "zirah kaki netherit□□apabila di kaki:□+6 zirah□+3 ketahanan zirah□+1 ketahanan balas",
  "item.minecraft.netherite_boots": "but netherit□□apabila di tapak kaki:□+3 zirah□+3 ketahanan zirah□+1 ketahanan balas",
  "item.minecraft.flint": "batu api",
  "item.minecraft.porkchop": "daging babi mentah",
  "item.minecraft.cooked_porkchop": "daging khinzir masak",
  "item.minecraft.painting": "lukisan",
  "item.minecraft.golden_apple": "epal emas",
  "item.minecraft.enchanted_golden_apple": "epal emas tersihir",
  "block.minecraft.oak_sign": "papan tanda oak",
  "block.minecraft.spruce_sign": "papan tanda cemara",
  "block.minecraft.birch_sign": "papan tanda birch",
  "block.minecraft.jungle_sign": "papan tanda rimba",
  "block.minecraft.acacia_sign": "papan tanda akasia",
  "block.minecraft.dark_oak_sign": "papan tanda oak gelap",
  "block.minecraft.crimson_sign": "papan tanda kirmizi",
  "block.minecraft.warped_sign": "papan tanda gila",
  "item.minecraft.bucket": "baldi",
  "item.minecraft.water_bucket": "baldi air",
  "item.minecraft.lava_bucket": "baldi lava",
  "item.minecraft.minecart": "kereta lombong",
  "item.minecraft.saddle": "pelana",
  "item.minecraft.redstone": "serbuk redstone",
  "item.minecraft.snowball": "bola salji",
  "item.minecraft.oak_boat": "sampan oak",
  "item.minecraft.leather": "kulit lembu",
  "item.minecraft.milk_bucket": "baldi susu",
  "item.minecraft.pufferfish_bucket": "sebaldi ikan buntal",
  "item.minecraft.salmon_bucket": "baldi salmon",
  "item.minecraft.cod_bucket": "sebaldi kod",
  "item.minecraft.tropical_fish_bucket": "baldi ikan tropika",
  "item.minecraft.brick": "bata",
  "item.minecraft.clay_ball": "bebola tanah liat",
  "block.minecraft.dried_kelp_block": "blok kelp kering",
  "item.minecraft.paper": "kertas",
  "item.minecraft.book": "buku",
  "item.minecraft.slime_ball": "bebola lendir",
  "item.minecraft.chest_minecart": "kereta lombong dengan peti",
  "item.minecraft.furnace_minecart": "kereta lombong dengan relau",
  "item.minecraft.egg": "telur",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "joran",
  "item.minecraft.clock": "jam",
  "item.minecraft.glowstone_dust": "serbuk batu menyala",
  "item.minecraft.cod": "kod mentah",
  "item.minecraft.salmon": "salmon mentah",
  "item.minecraft.tropical_fish": "ikan tropika",
  "item.minecraft.pufferfish": "ikan buntal",
  "item.minecraft.cooked_cod": "kod masak",
  "item.minecraft.cooked_salmon": "salmon masak",
  "item.minecraft.ink_sac": "pundi dakwat",
  "item.minecraft.red_dye": "pewarna merah",
  "item.minecraft.green_dye": "pewarna hijau",
  "item.minecraft.cocoa_beans": "biji koko",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "pewarna ungu",
  "item.minecraft.cyan_dye": "pewarna sian",
  "item.minecraft.light_gray_dye": "pewarna kelabu muda",
  "item.minecraft.gray_dye": "pewarna kelabu",
  "item.minecraft.pink_dye": "pewarna merah jambu",
  "item.minecraft.lime_dye": "pewarna hijau muda",
  "item.minecraft.yellow_dye": "pewarna kuning",
  "item.minecraft.light_blue_dye": "pewarna biru muda",
  "item.minecraft.magenta_dye": "pewarna magenta",
  "item.minecraft.orange_dye": "pewarna jingga",
  "item.minecraft.bone_meal": "serbuk tulang",
  "item.minecraft.blue_dye": "pewarna biru",
  "item.minecraft.brown_dye": "pewarna perang",
  "item.minecraft.black_dye": "pewarna hitam",
  "item.minecraft.white_dye": "pewarna putih",
  "item.minecraft.bone": "tulang",
  "item.minecraft.sugar": "gula",
  "block.minecraft.cake": "kek",
  "block.minecraft.white_bed": "katil putih",
  "block.minecraft.orange_bed": "katil jingga",
  "block.minecraft.magenta_bed": "katil magenta",
  "block.minecraft.light_blue_bed": "katil biru muda",
  "block.minecraft.yellow_bed": "katil kuning",
  "block.minecraft.lime_bed": "katil hijau muda",
  "block.minecraft.pink_bed": "katil merah jambu",
  "block.minecraft.gray_bed": "katil kelabu",
  "block.minecraft.light_gray_bed": "katil kelabu muda",
  "block.minecraft.cyan_bed": "katil sian",
  "block.minecraft.purple_bed": "katil ungu",
  "block.minecraft.blue_bed": "katil biru",
  "block.minecraft.brown_bed": "katil coklat",
  "block.minecraft.green_bed": "katil hijau",
  "block.minecraft.red_bed": "katil merah",
  "block.minecraft.black_bed": "katil hitam",
  "item.minecraft.cookie": "biskut",
  "item.minecraft.filled_map": "peta□#0",
  "item.minecraft.shears": "pemotong",
  "item.minecraft.melon_slice": "hirisan tembikai",
  "item.minecraft.dried_kelp": "kelp kering",
  "item.minecraft.pumpkin_seeds": "benih labu",
  "item.minecraft.melon_seeds": "benih tembikai",
  "item.minecraft.beef": "daging lembu mentah",
  "item.minecraft.cooked_beef": "stik",
  "item.minecraft.chicken": "ayam mentah",
  "item.minecraft.cooked_chicken": "ayam masak",
  "item.minecraft.rotten_flesh": "daging reput",
  "item.minecraft.ender_pearl": "mutiara ender",
  "item.minecraft.blaze_rod": "tongkat kemamang",
  "item.minecraft.ghast_tear": "air mata ghast",
  "item.minecraft.gold_nugget": "nuget emas",
  "item.minecraft.nether_wart": "ketuat nether",
  "item.minecraft.potion": "posyen yang tidak boleh dikraf□tiada kesan",
  "item.minecraft.glass_bottle": "botol kaca",
  "item.minecraft.spider_eye": "mata labah-labah",
  "item.minecraft.fermented_spider_eye": "mata labah-labah ditapai",
  "item.minecraft.blaze_powder": "serbuk kemamang",
  "item.minecraft.magma_cream": "krim magma",
  "block.minecraft.brewing_stand": "tapak membru",
  "block.minecraft.cauldron": "kawah",
  "item.minecraft.ender_eye": "mata ender",
  "item.minecraft.glistering_melon_slice": "potongan tembikai berkilauan",
  "item.minecraft.bat_spawn_egg": "telur penjelmaan kelawar",
  "item.minecraft.bee_spawn_egg": "telur penjelmaan lebah",
  "item.minecraft.blaze_spawn_egg": "telur penjelmaan kemamang",
  "item.minecraft.cat_spawn_egg": "telur penjelmaan kucing",
  "item.minecraft.cave_spider_spawn_egg": "telur penjelmaan lelabah gua",
  "item.minecraft.chicken_spawn_egg": "telur penjelmaan ayam",
  "item.minecraft.cod_spawn_egg": "telur penjelmaan kod",
  "item.minecraft.cow_spawn_egg": "telur penjelmaan lembu",
  "item.minecraft.creeper_spawn_egg": "telur penjelmaan creeper",
  "item.minecraft.dolphin_spawn_egg": "telur penjelmaan dolfin",
  "item.minecraft.donkey_spawn_egg": "telur penjelmaan keldai",
  "item.minecraft.drowned_spawn_egg": "telur penjelmaan si lemas",
  "item.minecraft.elder_guardian_spawn_egg": "telur penjelmaan penggawa penjaga",
  "item.minecraft.enderman_spawn_egg": "telur penjelmaan enderman",
  "item.minecraft.endermite_spawn_egg": "telur penjelmaan endermite",
  "item.minecraft.evoker_spawn_egg": "telur penjelmaan pawang",
  "item.minecraft.fox_spawn_egg": "telur penjelmaan rubah",
  "item.minecraft.ghast_spawn_egg": "telur penjelmaan ghast",
  "item.minecraft.guardian_spawn_egg": "telur penjelmaan penjaga",
  "item.minecraft.hoglin_spawn_egg": "telur penjelmaan hoglin",
  "item.minecraft.horse_spawn_egg": "telur penjelmaan kuda",
  "item.minecraft.husk_spawn_egg": "telur penjelmaan mumia",
  "item.minecraft.llama_spawn_egg": "telur penjelmaan llama",
  "item.minecraft.magma_cube_spawn_egg": "telur penjelmaan kiub magma",
  "item.minecraft.mooshroom_spawn_egg": "telur penjelmaan mooshroom",
  "item.minecraft.mule_spawn_egg": "telur penjelmaan baghal",
  "item.minecraft.ocelot_spawn_egg": "telur penjelmaan harimau oselot",
  "item.minecraft.panda_spawn_egg": "telur penjelmaan panda",
  "item.minecraft.parrot_spawn_egg": "telur penjelmaan burung nuri",
  "item.minecraft.phantom_spawn_egg": "telur penjelmaan hantu",
  "item.minecraft.pig_spawn_egg": "telur penjelmaan khinzir",
  "item.minecraft.piglin_spawn_egg": "telur penjelmaan piglin",
  "item.minecraft.pillager_spawn_egg": "telur penjelmaan penjarah",
  "item.minecraft.polar_bear_spawn_egg": "telur penjelmaan beruang kutub",
  "item.minecraft.pufferfish_spawn_egg": "telur penjelmaan ikan buntal",
  "item.minecraft.rabbit_spawn_egg": "telur penjelmaan arnab",
  "item.minecraft.ravager_spawn_egg": "telur penjelmaan pemusnah",
  "item.minecraft.salmon_spawn_egg": "telur penjelmaan salmon",
  "item.minecraft.sheep_spawn_egg": "telur penjelmaan biri-biri",
  "item.minecraft.shulker_spawn_egg": "telur penjelmaan shulker",
  "item.minecraft.silverfish_spawn_egg": "telur penjelmaan gegat",
  "item.minecraft.skeleton_spawn_egg": "telur penjelmaan kerangka",
  "item.minecraft.skeleton_horse_spawn_egg": "telur penjelmaan kuda kerangka",
  "item.minecraft.slime_spawn_egg": "telur penjelmaan lelendir",
  "item.minecraft.spider_spawn_egg": "telur penjelmaan lelabah",
  "item.minecraft.squid_spawn_egg": "telur penjelmaan sotong",
  "item.minecraft.stray_spawn_egg": "telur penjelmaan si liar",
  "item.minecraft.strider_spawn_egg": "telur penjelmaan perentas",
  "item.minecraft.trader_llama_spawn_egg": "telur penjelmaan llama saudagar",
  "item.minecraft.tropical_fish_spawn_egg": "telur penjelmaan ikan tropika",
  "item.minecraft.turtle_spawn_egg": "telur penjelmaan penyu",
  "item.minecraft.vex_spawn_egg": "telur penjelmaan bajang",
  "item.minecraft.villager_spawn_egg": "telur penjelmaan penduduk kampung",
  "item.minecraft.vindicator_spawn_egg": "telur penjelmaan pembela",
  "item.minecraft.wandering_trader_spawn_egg": "telur penjelmaan saudagar berkelana",
  "item.minecraft.witch_spawn_egg": "telur penjelmaan ahli sihir",
  "item.minecraft.wither_skeleton_spawn_egg": "telur penjelmaan kerangka wither",
  "item.minecraft.wolf_spawn_egg": "telur penjelmaan serigala",
  "item.minecraft.zoglin_spawn_egg": "telur penjelmaan zoglin",
  "item.minecraft.zombie_spawn_egg": "telur penjelmaan zombi",
  "item.minecraft.zombie_horse_spawn_egg": "telur penjelmaan zombi kuda",
  "item.minecraft.zombie_villager_spawn_egg": "telur penjelmaan zombi penduduk kampung",
  "item.minecraft.zombified_piglin_spawn_egg": "telur penjelmaan piglin terzombi",
  "item.minecraft.experience_bottle": "botol berisi penyihiran",
  "item.minecraft.fire_charge": "bebola api",
  "item.minecraft.writable_book": "buku dan bulu pelepah",
  "item.minecraft.written_book": "buku bertulis",
  "item.minecraft.emerald": "zamrud",
  "item.minecraft.item_frame": "bingkai item",
  "block.minecraft.flower_pot": "pasu bunga",
  "item.minecraft.carrot": "lobak",
  "item.minecraft.potato": "kentang",
  "item.minecraft.baked_potato": "kentang bakar",
  "item.minecraft.poisonous_potato": "kentang beracun",
  "item.minecraft.map": "peta kosong",
  "item.minecraft.golden_carrot": "lobak emas",
  "block.minecraft.skeleton_skull": "tengkorak kerangka",
  "block.minecraft.wither_skeleton_skull": "tengkorak kerangka wither",
  "block.minecraft.player_head": "kepala pemain",
  "block.minecraft.zombie_head": "kepala zombi",
  "block.minecraft.creeper_head": "kepala creeper",
  "block.minecraft.dragon_head": "kepala naga",
  "item.minecraft.carrot_on_a_stick": "lobak di atas kayu",
  "item.minecraft.warped_fungus_on_a_stick": "kulat gila di atas kayu",
  "item.minecraft.nether_star": "bintang nether",
  "item.minecraft.pumpkin_pie": "pai labu",
  "item.minecraft.firework_rocket": "roket bunga api",
  "item.minecraft.firework_star": "bintang bunga api",
  "item.minecraft.enchanted_book": "buku tersihir",
  "item.minecraft.nether_brick": "bata nether",
  "item.minecraft.quartz": "kuarza nether",
  "item.minecraft.tnt_minecart": "kereta lombong dengan tnt",
  "item.minecraft.hopper_minecart": "kereta lombong dengan corong tuang",
  "item.minecraft.prismarine_shard": "beling prismarin",
  "item.minecraft.prismarine_crystals": "kristal prismarin",
  "item.minecraft.rabbit": "arnab mentah",
  "item.minecraft.cooked_rabbit": "arnab masak",
  "item.minecraft.rabbit_stew": "stu arnab",
  "item.minecraft.rabbit_foot": "kaki arnab",
  "item.minecraft.rabbit_hide": "kulit arnab",
  "item.minecraft.armor_stand": "pempamer zirah",
  "item.minecraft.iron_horse_armor": "zirah kuda besi",
  "item.minecraft.golden_horse_armor": "zirah kuda emas",
  "item.minecraft.diamond_horse_armor": "zirah kuda berlian",
  "item.minecraft.leather_horse_armor": "zirah kuda kulit",
  "item.minecraft.lead": "tali pengikat",
  "item.minecraft.name_tag": "tag nama",
  "item.minecraft.command_block_minecart": "kereta lombong dengan blok arahan",
  "item.minecraft.mutton": "daging biri-biri mentah",
  "item.minecraft.cooked_mutton": "daging biri-biri masak",
  "block.minecraft.white_banner": "panji putih",
  "block.minecraft.orange_banner": "panji jingga",
  "block.minecraft.magenta_banner": "panji magenta",
  "block.minecraft.light_blue_banner": "panji biru muda",
  "block.minecraft.yellow_banner": "panji kuning",
  "block.minecraft.lime_banner": "panji hijau muda",
  "block.minecraft.pink_banner": "panji merah jambu",
  "block.minecraft.gray_banner": "panji kelabu",
  "block.minecraft.light_gray_banner": "panji kelabu muda",
  "block.minecraft.cyan_banner": "panji sian",
  "block.minecraft.purple_banner": "panji ungu",
  "block.minecraft.blue_banner": "panji biru",
  "block.minecraft.brown_banner": "panji perang",
  "block.minecraft.green_banner": "panji hijau",
  "block.minecraft.red_banner": "panji merah",
  "block.minecraft.black_banner": "panji hitam",
  "item.minecraft.end_crystal": "kristal end",
  "item.minecraft.chorus_fruit": "buah korus",
  "item.minecraft.popped_chorus_fruit": "buah korus muncul",
  "item.minecraft.beetroot": "ubi bit",
  "item.minecraft.beetroot_seeds": "benih ubi bit",
  "item.minecraft.beetroot_soup": "sup ubi bit",
  "item.minecraft.dragon_breath": "nafas naga",
  "item.minecraft.splash_potion": "posyen percikan yang tidak boleh dikraf□tiada kesan",
  "item.minecraft.spectral_arrow": "anak panah spektral",
  "item.minecraft.tipped_arrow": "anak panah disapu yang tidak boleh dikraf□tiada kesan",
  "item.minecraft.lingering_potion": "posyen berlarutan yang tidak boleh dikraf□tiada kesan",
  "item.minecraft.shield": "perisai",
  "item.minecraft.elytra": "elitra",
  "item.minecraft.spruce_boat": "sampan cemara",
  "item.minecraft.birch_boat": "sampan birch",
  "item.minecraft.jungle_boat": "sampan rimba",
  "item.minecraft.acacia_boat": "sampan akasia",
  "item.minecraft.dark_oak_boat": "sampan oak gelap",
  "item.minecraft.totem_of_undying": "totem abadi",
  "item.minecraft.shulker_shell": "cangkerang shulker",
  "item.minecraft.iron_nugget": "nuget besi",
  "item.minecraft.knowledge_book": "buku ilmu",
  "item.minecraft.debug_stick": "batang kayu nyahpepijat",
  "item.minecraft.music_disc_13": "cakera muzik□c418 - 13",
  "item.minecraft.music_disc_cat": "cakera muzik□c418 - cat",
  "item.minecraft.music_disc_blocks": "cakera muzik□c418 - blocks",
  "item.minecraft.music_disc_chirp": "cakera muzik□c418 - chirp",
  "item.minecraft.music_disc_far": "cakera muzik□c418 - far",
  "item.minecraft.music_disc_mall": "cakera muzik□c418 - mall",
  "item.minecraft.music_disc_mellohi": "cakera muzik□c418 - mellohi",
  "item.minecraft.music_disc_stal": "cakera muzik□c418 - stal",
  "item.minecraft.music_disc_strad": "cakera muzik□c418 - strad",
  "item.minecraft.music_disc_ward": "cakera muzik□c418 - ward",
  "item.minecraft.music_disc_11": "cakera muzik□c418 - 11",
  "item.minecraft.music_disc_wait": "cakera muzik□c418 - wait",
  "item.minecraft.music_disc_pigstep": "cakera muzik□lena raine - pigstep",
  "item.minecraft.trident": "trisula□□apabila dalam tangan utama:□+8 kecederaan serangan□-2.9 kelajuan serangan",
  "item.minecraft.phantom_membrane": "membran khayalan",
  "item.minecraft.nautilus_shell": "cangkerang nautilus",
  "item.minecraft.heart_of_the_sea": "jiwa laut",
  "item.minecraft.crossbow": "busur silang",
  "item.minecraft.suspicious_stew": "stu kesangsian",
  "block.minecraft.loom": "alat tenun",
  "item.minecraft.flower_banner_pattern": "corak panji□lambang bunga",
  "item.minecraft.creeper_banner_pattern": "corak panji□lambang creeper",
  "item.minecraft.skull_banner_pattern": "corak panji□lambang tengkorak",
  "item.minecraft.mojang_banner_pattern": "corak panji□benda",
  "item.minecraft.globe_banner_pattern": "corak panji□glob",
  "item.minecraft.piglin_banner_pattern": "corak panji□muncung",
  "block.minecraft.composter": "pembuat kompos",
  "block.minecraft.barrel": "tong",
  "block.minecraft.smoker": "penyalai",
  "block.minecraft.blast_furnace": "relau bagas",
  "block.minecraft.cartography_table": "meja kartografi",
  "block.minecraft.fletching_table": "meja pertukangan panah",
  "block.minecraft.grindstone": "batu pengasah",
  "block.minecraft.lectern": "meja syarahan",
  "block.minecraft.smithing_table": "meja tukang besi",
  "block.minecraft.stonecutter": "pemotong batu",
  "block.minecraft.bell": "genta",
  "block.minecraft.lantern": "tanglung",
  "block.minecraft.soul_lantern": "tanglung roh",
  "item.minecraft.sweet_berries": "beri manis",
  "block.minecraft.campfire": "unggun api",
  "block.minecraft.soul_campfire": "unggun api roh",
  "block.minecraft.shroomlight": "lampu cendawan",
  "item.minecraft.honeycomb": "indung madu",
  "block.minecraft.bee_nest": "sarang lebah",
  "block.minecraft.beehive": "sarang lebah buatan",
  "item.minecraft.honey_bottle": "botol madu",
  "block.minecraft.honey_block": "blok madu",
  "block.minecraft.honeycomb_block": "blok indung madu",
  "block.minecraft.lodestone": "batu magnet",
  "block.minecraft.netherite_block": "blok netherit",
  "block.minecraft.ancient_debris": "puing purba",
  "block.minecraft.target": "sasaran",
  "block.minecraft.crying_obsidian": "obsidian menangis",
  "block.minecraft.blackstone": "batu hitam",
  "block.minecraft.blackstone_slab": "papak batu hitam",
  "block.minecraft.blackstone_stairs": "tangga batu hitam",
  "block.minecraft.gilded_blackstone": "batu hitam bersepuh",
  "block.minecraft.polished_blackstone": "batu hitam digilap",
  "block.minecraft.polished_blackstone_slab": "papak batu hitam digilap",
  "block.minecraft.polished_blackstone_stairs": "tangga batu hitam digilap",
  "block.minecraft.chiseled_polished_blackstone": "batu hitam digilap terpahat",
  "block.minecraft.polished_blackstone_bricks": "bata batu hitam digilap",
  "block.minecraft.polished_blackstone_brick_slab": "papak bata batu hitam digilap",
  "block.minecraft.polished_blackstone_brick_stairs": "tangga bata batu hitam digilap",
  "block.minecraft.cracked_polished_blackstone_bricks": "bata batu hitam digilap rekah",
  "block.minecraft.respawn_anchor": "penambat penjelmaan",
}
export const ms_my = items; 
